document.addEventListener("click", async event => {
  const button = event.target.closest("[data-fipe-history-retry]");
  if (!button || button.disabled) return;

  const warning = button.closest("[data-fipe-history-warning]");
  const message = warning.querySelector("[data-fipe-history-message]");
  button.disabled = true;
  button.textContent = "Consultando...";

  try {
    const response = await fetch(button.dataset.url, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store"
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();
    if (!data || !data.prices || Array.isArray(data.prices)) {
      throw new Error("Resposta FIPE inválida");
    }

    const chart = window.Chartkick && window.Chartkick.charts[button.dataset.chartId];
    if (!chart) throw new Error("Gráfico FIPE indisponível");

    chart.updateData(data.prices);
    if (data.unavailable) {
      message.textContent = "Histórico FIPE parcial: o serviço externo ainda não respondeu. Exibindo as referências disponíveis.";
    } else {
      warning.classList.add("d-none");
    }
  } catch (error) {
    console.error("Erro ao atualizar Histórico FIPE:", error);
    message.textContent = "Não foi possível atualizar o Histórico FIPE. Tente novamente.";
    warning.classList.remove("d-none");
  } finally {
    button.disabled = false;
    button.textContent = "Tentar novamente";
  }
});
